import { IRootState } from '../../../store'
import { IAllergyOptions } from '../store/patientAllergies.types'

export const getPatientAllergySelector = (state: IRootState): IAllergyOptions | null | undefined =>
  state.patientAllergies.allergy
